import { createHook } from 'react-sweet-state';

import { Store } from './store';

export const useIsMultiSelectActive = createHook(Store, {
	selector: (state) => state.isMultiSelectActive,
});
